<template>
  <section class="dashboard-premium">
    <!-- Overlay de Seguridad -->
    <div v-if="!autenticado" class="auth-overlay">
      <div class="auth-card">
        <b-icon icon="lock-outline" size="is-large" type="is-primary"></b-icon>
        <h2 class="title is-3 has-text-white">Acceso Restringido</h2>
        <p class="subtitle is-6 has-text-grey-light">Ingrese la clave maestra para continuar</p>
        <b-field>
          <b-input 
            type="password" 
            v-model="passwordInput" 
            placeholder="••••" 
            password-reveal
            @keyup.enter.native="verificarClave"
            centered
          ></b-input>
        </b-field>
        <b-button 
          type="is-primary" 
          expanded 
          @click="verificarClave"
          :loading="cargando"
        >Entrar</b-button>
        <p v-if="errorPass" class="has-text-danger mt-2">Contraseña incorrecta</p>
      </div>
    </div>

    <!-- Contenido del Dashboard -->
    <div v-else class="dashboard-content container">
      <header class="dashboard-header animate__animated animate__fadeInDown">
        <div class="header-text">
          <h1 class="title is-3 has-text-white mb-2">Panel de Control</h1>
          <p class="subtitle is-6 has-text-grey-light">Gestiona el concurso y configuraciones globales</p>
        </div>
        <div class="header-actions">
           <b-button 
             type="is-primary" 
             outlined
             icon-left="cog" 
             @click="irA('/configurar')"
           >
             Configuración
           </b-button>
        </div>
      </header>

      <div class="columns is-multiline mt-5">
        <div
          class="column is-one-quarter-desktop is-half-tablet"
          v-for="(modulo, i) in modulos"
          :key="i"
        >
          <div class="card-modulo glass animate__animated animate__fadeInUp" :style="{ '--delay': (i * 0.1) + 's' }" @click="irA(modulo.ruta)">
            <div class="card-icon">
              <b-icon :icon="modulo.icon" size="is-medium"></b-icon>
            </div>
            <div class="card-body">
              <h3 class="modulo-titulo">{{ modulo.titulo }}</h3>
              <p class="modulo-count">{{ modulo.total }} <span class="label-txt">registros</span></p>
            </div>
            <div class="card-footer-info">
              <span class="view-link">Gestionar <b-icon icon="chevron-right" size="is-small"></b-icon></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
  </section>
</template>

<script>
import HttpService from '../Servicios/HttpService';

export default {
  name: 'DashboardHome',
  data() {
    return {
      cargando: false,
      autenticado: false,
      passwordInput: '',
      errorPass: false,
      eventos: [],
      restaurantes: [],
      productos: [],
      participantes: [],
      totales: {
        eventos: 0,
        restaurantes: 0,
        productos: 0,
        participantes: 0,
        sorteos: 0
      }
    };
  },
  computed: {
    modulos() {
      return [
        { titulo: 'Eventos', total: this.totales.eventos, icon: 'calendar-star', ruta: '/eventos' },
        { titulo: 'Restaurantes', total: this.totales.restaurantes, icon: 'store', ruta: '/restaurantes' },
        { titulo: 'Productos', total: this.totales.productos, icon: 'food', ruta: '/productos' },
        { titulo: 'Participantes', total: this.totales.participantes, icon: 'account-group', ruta: '/participantes' },
        { titulo: 'Sorteos', total: this.totales.sorteos, icon: 'clover', ruta: '/sorteos' },
        { titulo: 'Estadísticas', total: 'Ver listado', icon: 'chart-bar', ruta: '/estadisticas' },
        { titulo: 'Gráficos', total: 'Ver análisis', icon: 'chart-bubble', ruta: '/graficos' }
      ];
    }
  },
  mounted() {
    this.verificarSesionExistente();
  },
  methods: {
    verificarSesionExistente() {
      const authData = localStorage.getItem('dashboard_auth');
      if (authData) {
        const { timestamp } = JSON.parse(authData);
        const dosHoras = 2 * 60 * 60 * 1000;
        if (Date.now() - timestamp < dosHoras) {
          this.autenticado = true;
          if (!localStorage.getItem('rol')) localStorage.setItem('rol', 'administrador');
          this.cargarDatos();
        }
      }
    },
    verificarClave() {
      if (this.passwordInput === '1') {
        const authData = { timestamp: Date.now() };
        localStorage.setItem('dashboard_auth', JSON.stringify(authData));
        localStorage.setItem('rol', 'administrador');
        this.autenticado = true;
        this.cargarDatos();
      } else {
        this.errorPass = true;
        setTimeout(() => { this.errorPass = false; }, 3000);
      }
    },

    cargarDatos() {
      this.cargando = true;
      Promise.all([
        HttpService.registrar('dashboard.php', { accion: 'totales' }),
        HttpService.registrar('eventos.php', { accion: 'obtener' }),
        HttpService.registrar('restaurantes.php', { accion: 'obtener' }),
        HttpService.registrar('productos.php', { accion: 'obtener' }),
        HttpService.registrar('participantes.php', { accion: 'obtener' })
      ]).then(([tot, evs, rests, prods, partes]) => {
        this.totales = tot;
        this.eventos = evs || [];
        this.restaurantes = rests || [];
        this.productos = prods || [];
        this.participantes = partes || [];
        this.cargando = false;
      }).catch(() => {
        this.cargando = false;
      });
    },
    irA(ruta) {
      if (ruta) {
         this.$router.push(ruta);
      }
    }
  }
};
</script>

<style scoped>
.dashboard-premium {
  min-height: 100vh;
  /* Removed light gradient to inherit global dark theme */
  padding: 40px 20px;
  font-family: 'Poppins', sans-serif;
}

/* Glassmorphism Dark Mode */
.glass {
  background: rgba(30, 41, 59, 0.7) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.3);
}

.auth-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  background: linear-gradient(rgba(15, 23, 42, 0.85), rgba(15, 23, 42, 0.92)),
    url('https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80') no-repeat center center;
  background-size: cover;
}

.auth-card {
  width: 100%;
  max-width: 400px;
  padding: 40px;
  border-radius: 20px;
  text-align: center;
  background: rgba(30, 41, 59, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255,255,255,0.15);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end; /* Align bottom */
  margin-bottom: 3rem;   /* More space */
  flex-wrap: wrap;
  gap: 20px;
}

.card-modulo {
  border-radius: 16px;
  padding: 24px;
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  animation-delay: var(--delay);
}

.card-modulo:hover {
  transform: translateY(-10px);
  background: rgba(51, 65, 85, 0.9) !important;
  box-shadow: 0 15px 45px rgba(0, 0, 0, 0.3);
}

.card-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);
}

.modulo-titulo {
  font-size: 1.1rem;
  font-weight: 600;
  color: #fff; /* Dark mode text */
  margin-bottom: 0.5rem;
}

.modulo-count {
  font-size: 1.5rem;
  font-weight: 700;
  color: #60a5fa; /* Lighter blue */
}

.label-txt {
  font-size: 0.8rem;
  color: #94a3b8; /* Slate 400 */
  font-weight: 400;
}

.card-footer-info {
  margin-top: 1.5rem;
  border-top: 1px solid rgba(255,255,255,0.05);
  padding-top: 1rem;
}

.view-link {
  font-size: 0.85rem;
  color: #60a5fa;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;
}


.opacity-7 { opacity: 0.7; }

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.animate__animated {
  animation-duration: 0.8s;
  animation-fill-mode: both;
}

.animate__fadeInUp { animation-name: fadeInUp; }
</style>

